import { useState, useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import AcCharge from '@/components/UI/svg/Wave2/Icon/AcCharge';
import CarCharge from '@/components/UI/svg/Wave2/Icon/CarCharge';
import PsCharge from '@/components/UI/svg/Wave2/Icon/PsCharge';
import SolarCharge from '@/components/UI/svg/Wave2/Icon/SolarCharge';

const chargeList = [
    {
        name: 'detail.ac',
        img: 'section_m_ac',
        icon: <AcCharge width="35px" height="35px" fillColor="#FFF" />,
    },
    {
        name: 'detail.power_station',
        img: 'section_m_ps',
        icon: <PsCharge width="35px" height="35px" fillColor="#FFF" />,
    },
    {
        name: 'detail.solar',
        img: 'section_m_solar',
        icon: <SolarCharge width="35px" height="35px" fillColor="#FFF" />,
    },
    {
        name: 'detail.car',
        img: 'section_m_car',
        icon: <CarCharge width="35px" height="35px" fillColor="#FFF" />,
    },
];

export default function M() {
    const { useLang } = useGlobal();
    const { t } = useLang('wave2portableairconditioner');
    const [active, setActive] = useState<number>(1);

    useEffect(() => {
        AniContainer.create({
            syncFromTo: [['.wave2-detail-M .viewport-wrapper .title', { opacity: 0 }, { opacity: 1 }]],
            triggerElement: '.wave2-detail-M .viewport-wrapper .title',
            triggerHook: 1,
            offset: '5%',
            duration: '10%',
        });
        AniContainer.create({
            syncFromTo: [['.wave2-detail-M .viewport-wrapper .desc', { opacity: 0 }, { opacity: 1 }]],
            triggerElement: '.wave2-detail-M .viewport-wrapper .desc',
            triggerHook: 1,
            offset: '5%',
            duration: '10%',
        });

        const targetEl = document.querySelector('.wave2-detail-M .charge-list') as HTMLDivElement;
        AniContainer.create({
            triggerElement: '.wave2-detail-M .viewport-wrapper .charge-list',
            triggerHook: 0.5,
            offset: 0,
            duration: targetEl?.offsetHeight || 1400,
            onProcess: (process: number) => {
                const number = Math.ceil(process / 0.25);
                setActive(number);
            },
        });
    }, []);

    return (
        <div className={`wave2-detail-M ${css.wave2DetailM}`}>
            <div className="viewport-wrapper">
                <div className="sticky-wrapper">
                    <div className="text-wrapper">
                        <p className="title">{t('detail.sectionM_title')}</p>
                        <p className="desc">{t('detail.sectionM_desc')}</p>
                    </div>
                </div>
                <div className={`charge-list active-0${active}`}>
                    {chargeList.map((item, i) => (
                        <div className="charge" key={i}>
                            <NextImage
                                webpSrc={require(`@publicLocal/wave2/detail/pc/${item.img}.webp`)}
                                src={require(`@publicLocal/wave2/detail/pc/${item.img}.jpg`)}
                                alt={t(item.name)}
                                aria-label={t(item.name)}
                            />
                            <div className="icon">{item.icon}</div>
                            <p className="text">{t(item.name)}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
